import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-338d387b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "search-section" }
const _hoisted_2 = { class: "d-inline-flex justify-content-between w-100" }

import { PropType, ref, watch } from 'vue'
import BarTextField from '@/components/BarTextField'
import locales from './SessionSearch.locales.en.json'
import { MicroFilter } from './SessionSeach.interfaces'
import { useSessionRegistryStore } from '@/components/SessionRegistryStore'
import { SessionRegistryStore } from '@/components/SessionRegistryStore/SessionRegistryStore.interfaces'
import MicroFilterPopover from './MicroFilterPopover.vue'
import MicroFilterAccordion from './MicroFilterAccordion.vue'
import MicroFilterMobileAccordion from './MicroFilterMobileAccordion.vue'
import { CourseTag } from '@/types/api'
import { SessionListItemViewModel } from '../SessionListItem/SessionListItem.interfaces'


export default /*#__PURE__*/_defineComponent({
  __name: 'SessionSearch',
  props: {
  microFilter: {
    type: Object as PropType<MicroFilter>,
    required: true
  },
  isEbar: {
    type: Boolean,
    required: true
  },
  courseTags: {
    type: Array as PropType<CourseTag[]>,
    default: () => []
  },
  sessions: {
    type: Array as PropType<SessionListItemViewModel[]>,
    default: () => []
  }
},
  emits: ['search-text-updated', 'update:micro-filter'],
  setup(__props, { emit: __emit }) {

const { sessionState }: SessionRegistryStore = useSessionRegistryStore()
const searchText = ref('')



const emit = __emit
watch(searchText, () => { emit('search-text-updated', searchText.value) })

const showMicroFilter = ref(false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(BarTextField), {
          modelValue: searchText.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
          class: "partial-width",
          type: "text",
          placeholder: _unref(locales).label_search,
          label: "Search Sessions and Webinars",
          "label-class": "visually-hidden",
          "auto-trim": true,
          debounce: 500,
          disabled: _unref(sessionState).isLoading
        }, null, 8, ["modelValue", "placeholder", "disabled"]),
        (__props.isEbar)
          ? (_openBlock(), _createBlock(MicroFilterPopover, {
              key: 0,
              "micro-filter": __props.microFilter,
              "onUpdate:microFilter": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:micro-filter', $event)))
            }, null, 8, ["micro-filter"]))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              id: "microfilter",
              class: "btn",
              "aria-label": "open micro filter menu",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (showMicroFilter.value = !showMicroFilter.value))
            }))
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(MicroFilterMobileAccordion, {
          "micro-filter": __props.microFilter,
          "course-tags": __props.courseTags,
          sessions: __props.sessions,
          "onUpdate:microFilter": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:micro-filter', $event)))
        }, null, 8, ["micro-filter", "course-tags", "sessions"])
      ], 512), [
        [_vShow, !__props.isEbar && showMicroFilter.value]
      ])
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(MicroFilterAccordion, {
        "micro-filter": __props.microFilter,
        "course-tags": __props.courseTags,
        sessions: __props.sessions,
        "onUpdate:microFilter": _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:micro-filter', $event)))
      }, null, 8, ["micro-filter", "course-tags", "sessions"])
    ], 512), [
      [_vShow, !__props.isEbar && showMicroFilter.value]
    ])
  ], 64))
}
}

})